import { I18nComponente } from "@/types/gerais"

export const OTabelaProjetosi18n: I18nComponente = {
  "pt-BR": {
    nome: "nome",
    codigo: "código",
    usuariosResponsaveis: "usuários responsáveis",
    gruposDeProjetos: "grupos de projetos",
    pesquisarPorNomeDoProjeto: "pesquisar por nome do projeto",
    pesquisarPorCodigoDoProjeto: "pesquisar por código do projeto",
    pesquisarPorUsuarioResponsavel: "pesquisar por usuário responsável",
    limpar: 'Limpar',
    aplicar: 'Aplicar',
    editar: "editar",
    excluir: "excluir",
    arquivar: "arquivar",
    desarquivar: "desarquivar",
    deletar: "deletar",
    voltar: "voltar",
    simExcluir: "sim, excluir",
    sucesso: "Sucesso!",
    erro: "Erro!",
    tenteNovamenteMaisTarde: "Tente novamente mais tarde",
    ocorreuUmErroAoBuscarOsProjetos: "Ocorreu um erro ao buscar os projetos",
    projetosArquivado: "Projetos arquivado!",
    projetoDesarquivado: "Projeto desarquivado!",
    naoFoiPossivelArquivarProjeto: "Não foi possível arquivar o projeto!",
    naoFoiPossivelDesarquivarProjeto: "Não foi possível desarquivar o projeto!",
    projetoDeletado: "Projeto deletado!",
    naoFoiPossivelDeletarProjeto: "Não foi possível deletar o projeto!",
    projetoSeraPermanentementeRemovido: "o projeto  será permanentemente removido do sistema e não será possível recuperá-lo"
  },
  "es-CO": {
    nome: "nombre",
    codigo: "código",
    usuariosResponsaveis: "usuarios responsables",
    gruposDeProjetos: "grupos de proyectos",
    pesquisarPorNomeDoProjeto: "buscar por nombre del proyecto",
    pesquisarPorCodigoDoProjeto: "buscar por código del proyecto",
    pesquisarPorUsuarioResponsavel: "buscar por usuario responsable",
    limpar: "Borrar",
    aplicar: "Aplicar",
    editar: "editar",
    excluir: "borrar",
    arquivar: "archivar",
    desarquivar: "desarchivar",
    deletar: "borrar",
    voltar: "volver",
    simExcluir: "sí, borrar",
    sucesso: "Éxito!",
    erro: "Error!",
    tenteNovamenteMaisTarde: "Inténtelo de nuevo más tarde",
    ocorreuUmErroAoBuscarOsProjetos: "Se produjo un error al buscar los proyectos",
    projetosArquivado: "Proyectos archivado!",
    projetoDesarquivado: "Proyecto desarquivado!",
    naoFoiPossivelArquivarProjeto: "No fue posible archivar el proyecto!",
    naoFoiPossivelDesarquivarProjeto: "No fue posible desarquivar el proyecto!",
    projetoDeletado: "Proyecto eliminado!",
    naoFoiPossivelDeletarProjeto: "No fue posible borrar el proyecto!",
    projetoSeraPermanentementeRemovido: "el proyecto será eliminado permanentemente del sistema y no se podrá recuperar"
  }
}
